import { db } from '../firebase';
import { 
  collection, 
  doc, 
  getDoc, 
  getDocs, 
  query, 
  where 
} from 'firebase/firestore';

/**
 * Get all chats for a specific user
 * @param {string} userId - The user ID to get chats for
 * @returns {Promise<Array>} - Array of chat objects
 */
export const getUserChats = async (userId) => {
  if (!userId) {
    throw new Error('User ID is required');
  }
  
  try {
    // Call the admin API endpoint to get user chats
    const apiUrl = 'https://us-central1-dutiap-project.cloudfunctions.net/apiadmin/getuserchats';
    
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId })
    });

    if (!response.ok) {
      throw new Error(`Error getting user chats: ${response.statusText}`);
    }

    const data = await response.json();
    return data.chats || [];
  } catch (error) {
    console.error('Error fetching user chats:', error);
    throw error;
  }
};

/**
 * Get messages from a specific chat
 * @param {string} chatId - The chat ID to get messages from
 * @param {number} page - Page number for pagination (starts from 0)
 * @param {number} limit - Number of messages per page
 * @returns {Promise<Object>} - Object containing messages, users, and pagination info
 */
export const getChatMessages = async (chatId, page = 0, limit = 50) => {
  if (!chatId) {
    throw new Error('Chat ID is required');
  }
  
  try {
    // Call the admin API endpoint to get chat messages
    const apiUrl = 'https://us-central1-dutiap-project.cloudfunctions.net/apiadmin/getchatmessages';
    
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ chatId, page, limit })
    });

    if (!response.ok) {
      throw new Error(`Error getting chat messages: ${response.statusText}`);
    }

    const data = await response.json();
    return {
      messages: data.messages || [],
      users: data.users || {},
      hasMore: data.hasMore || false
    };
  } catch (error) {
    console.error('Error fetching chat messages:', error);
    throw error;
  }
};